import React from "react";

export const ReviewContext = React.createContext();